import styled from "styled-components";
import { COLORS, responsive } from "../../styles/constants.style";

export const ViewUserWrapper = styled.div`
  .view-message {
    padding-left: 16px;
    ${responsive.MOBILE`
        padding: 0px 16px;
    `}
  }

  .message-country {
    margin-bottom: 24px;
  }

  .message-description {
    margin-bottom: 24px;
  }

  .select-preferences {
    border-top: 1px dashed ${COLORS.primary_light_blue4};
    margin: 0 0 16px 0;
  }

  .message-id {
    .max-width {
      max-width: 250px;
    }
  }

  .anchor-text {
    color: ${COLORS.primary_light_blue6};
  }
`;
